import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAssignedDevices,
  setDeviceOptions,
  updateDeviceInState,
  addDeviceToState,
  removeDeviceFromState,
} from "../../../../../redux/buildings/buildingDevicesSlice";
import {
  fetchAllDevices,
  fetchAssignedDevices,
  addDevice,
  removeDevice,
  updateDevice,
  createNewDevice,
} from "../services/buildingDeviceService";

export const useBuildingDevices = (buildingID) => {
  const dispatch = useDispatch();
  const { assignedDevices, deviceOptions } = useSelector(
    (state) => state.buildingDevices
  );

  const loadDeviceOptions = useCallback(async () => {
    try {
      const options = await fetchAllDevices();
      dispatch(setDeviceOptions(options));
    } catch (error) {
      console.error("Error loading device options:", error);
    }
  }, [dispatch]);

  const loadAssignedDevices = useCallback(async () => {
    if (buildingID) {
      try {
        const devices = await fetchAssignedDevices(buildingID);
        dispatch(setAssignedDevices(devices));
      } catch (error) {
        console.error("Error loading assigned devices:", error);
      }
    }
  }, [buildingID, dispatch]);

  const addDeviceToBuilding = () => {};
  // useCallback(
  //   async (deviceID) => {
  //     if (buildingID && deviceID) {
  //       try {
  //         const newDevice = await addDevice(buildingID, deviceID);
  //         dispatch(addDeviceToState(newDevice));
  //       } catch (error) {
  //         console.error("Error adding device:", error);
  //       }
  //     }
  //   },
  //   [buildingID, dispatch]
  // );

  const removeDeviceFromBuilding = () => {};
  // useCallback(
  //   async (deviceID) => {
  //     if (deviceID) {
  //       try {
  //         await removeDevice(deviceID);
  //         dispatch(removeDeviceFromState(deviceID));
  //       } catch (error) {
  //         console.error("Error removing device:", error);
  //       }
  //     }
  //   },
  //   [dispatch]
  // );

  const updateDeviceData = useCallback(
    async (deviceID, deviceData) => {
      if (deviceID && deviceData) {
        try {
          const updatedDevice = await updateDevice(deviceID, deviceData);
          dispatch(updateDeviceInState(updatedDevice));
        } catch (error) {
          console.error("Error updating device:", error);
        }
      }
    },
    [dispatch]
  );

  return {
    assignedDevices,
    deviceOptions,
    loadAssignedDevices,
    loadDeviceOptions,
    addDeviceToBuilding,
    removeDeviceFromBuilding,
    updateDeviceData,
  };
};
